import { useEffect, useState } from "react";
import LabelInput from "../../Component/labelInput";
import PageTitle from "../../module/pageTitle";
import { Submitbtn } from "../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import {
  getCategoryList,
  getProductList,
  getProductTypeList,
} from "../Admin/adminSlice";
import moment from "moment";
import DropdownWithClear from "../../Component/dropdownWithClear";
import AdminTable from "../../Component/adminTable";
// import { getCouponTypeList, getTransactionDetails } from "../cxoSlice";
import DatePicker from "../../Component/datePicker";
import { stockSellingType } from "../../Utils/dataConstant";
import { showSnackbar, hideSnackbar } from "../../store/slices/snackbarSlice";
import { getSellingSourceList } from "../Publication/publicationSlice";
const ProductOrderHistory = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [productList, setProductList] = useState<any>([]);
  const [product, setProduct] = useState<any>("");
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
    const [sellingSource, setSellingSource] = useState<any>("");
    const [sellingSourceList, setSellingSourceList] = useState<any>([]);
    const [sellingType, setSellingType] = useState<any>(""); 
    const [revenueList, setRevenueList] = useState<any>([]);

  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );

   
 
  }, []);

  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
    const postData = {
      productTypeId: productType?._id,
      categoryId: value?._id,
    };
    dispatch(
      getProductList({
        params: postData,
        callback: (res: any) => {
          setProductList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };

  const onchangeSellingSource = (value: any) => {
    setSellingSource(value);
  };
  const onchangeSellingType = (value: any) => {
    setSellingType(value);
    dispatch(
        getSellingSourceList({
          callback: (res: any) => {
              setSellingSourceList(res?.data);
          },
          errorCallback: () => { },
        })
      );
  }; 

  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };
  

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      startDate: startDate,
      endDate: endDate,
      productTypeId: productType?._id,
      categoryId: category?._id,
      productId: product?._id, 
    };
    if (
      postData["productTypeId"] === null ||
      postData["productTypeId"] === undefined ||
      postData["productTypeId"] === ""
    ) {
      delete postData["productTypeId"];
    }
    if (
      postData["categoryId"] === null ||
      postData["categoryId"] === undefined ||
      postData["categoryId"] === ""
    ) {
      delete postData["categoryId"];
    }
    if (
      postData["productId"] === null ||
      postData["productId"] === undefined ||
      postData["productId"] === ""
    ) {
      delete postData["productId"];
    }
 
 
  };
  const validations = () => {
    let valid = false;
    if (startDate === "" || endDate === "") {
      valid = true;
    }
    return valid;
  };

  const renderTable = () => {
    return (
      <div className="mt-4">
        <AdminTable
          tableData={ revenueList ?  revenueList : []}
          pagename={"TransactionDetails"}
          tableHead={[
            "S.N",
            "Name",
            "Product Type",
            "Category",
            "Product",
            "Units Ordered",
            "Ordered Amount",
          ]}
        />
      </div>
    );
  };
  let sum: any = 0;
  for (let i = 0; i < revenueList.length; i++) {
    sum += revenueList[i].Amount;
  }
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Product Order History"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Start Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"End Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Select Product Type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Category"} />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
             
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Selling Type"} />
                <DropdownWithClear
                  labelName={"Select Selling Type "}
                  setInputText={(value: any) => onchangeSellingType(value)}
                  options={stockSellingType}
                  value={sellingType}
                />
              </div> 
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Selling Source"} />
                <DropdownWithClear
                  labelName={"Select Selling Source "}
                  setInputText={(value: any) => onchangeSellingSource(value)}
                  options={sellingSourceList}
                  value={sellingSource}
                />
              </div>
        
         
      
              <div className="col-md-4 mt-3">
                <div className="col-md-4 pt-2">
                  <Submitbtn name={"Search"} disabled={validations()} />
                </div>
              </div>
            </div>
          </form>
        </div>
    
        <div className="bxshadow borderRadius p-1">
          <div>{renderTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default ProductOrderHistory;
